export enum ReceiptStatus {
  pending = 'pending',
  inReview = 'in_review',
  approved = 'approved',
  rejected = 'rejected',
  paid = 'paid',
}

export interface Receipt {
  id: string;
  memberId: string;
  dependentId?: string;
  employerId: string;
  providerName?: string;
  serviceDate?: Date;
  amount: number;
  categoryId?: string;
  visitId?: string;
  procedureCodes?: string[];
  diagnosisCodes?: string[];
  serviceName?: string;
  serviceDescription?: string;
  receiptImageUrl?: string;
  ocrText?: string;
  ocrData?: Record<string, unknown>;
  status: ReceiptStatus;
  approvedAmount?: number;
  rejectionReason?: string;
  adminNotes?: string;
  reviewedBy?: string;
  reviewedAt?: Date;
  isDuplicate: boolean;
  requiresReview: boolean;
  isCatastrophicClaim: boolean;
  stopLossClaimId?: string;
  stopLossStatus?: string;
  reimbursementSource?: string;
  metadata?: Record<string, unknown>;
  createdAt: Date;
  lastUpdated: Date;
}

